import React from "react";
import { Row, Col } from "antd";
import { IconPhone, IconMail } from "@tabler/icons-react";
import "./TopBar.scss";

const TopBar = () => {
  return (
    <div className="top-bar">
      <Row>
        <Col className="contact-item" justify="start">
          <IconPhone size={16} />
          <a href="tel:+19548369299">954-836-9299</a>
        </Col>
        <Col className="contact-item" justify="end">
          <IconMail size={16} />
          <a href="mailto:info@skyautofinance.com">info@skyautofinance.com</a>
        </Col>
      </Row>
    </div>
  );
};

export default TopBar;
